export function mapResponseToCashbox(response: GM.Cashbox.Response.Status.Success): GM.Cashbox.Cashbox | null {
  if (response.data && response.data.length > 0) {
    return {
      id: response.data[0].hwid,
    };
  }

  return null;
}
